import { defineComponent } from "vue";
import slugify from "./component-library76.mjs";
import externalIcon from "./component-library212.mjs";
import { getConfig } from "./component-library2.mjs";
const LinkButtonProps = {
  tag: {
    type: String,
    default: "a"
  },
  tealiumName: {
    type: String,
    default: null
  },
  tealiumSuffix: {
    type: String,
    default: ""
  },
  label: {
    type: String,
    default: void 0
  },
  disabled: Boolean,
  primary: Boolean,
  secondary: Boolean,
  noStyling: Boolean,
  transparent: Boolean,
  transparentLight: Boolean,
  borderless: Boolean,
  text: Boolean,
  textNeutral: Boolean,
  isWide: Boolean,
  to: {
    type: [String, Object],
    default: null
  },
  isExternal: Boolean,
  sameWindow: Boolean,
  smallPadding: Boolean
};
const _sfc_main = defineComponent({
  name: "LinkButton",
  components: {
    externalIcon
  },
  props: LinkButtonProps,
  emits: ["click"],
  data() {
    return {
      slotContent: ""
    };
  },
  computed: {
    classes() {
      const modifier = [];
      modifier.push("link-button");
      if (this.isWide)
        modifier.push("link-button--is-wide");
      if (this.primary)
        modifier.push("link-button--primary");
      if (this.secondary)
        modifier.push("link-button--secondary");
      if (!this.noStyling)
        modifier.push("link-button--base-styling");
      if (this.transparent)
        modifier.push("link-button--transparent");
      if (this.transparentLight)
        modifier.push("link-button--transparent-light");
      if (this.borderless)
        modifier.push("link-button--borderless");
      if (this.text)
        modifier.push("link-button--text");
      if (this.textNeutral)
        modifier.push("link-button--text link-button--text-neutral");
      if (this.disabled)
        modifier.push("link-button--disabled");
      if (this.smallPadding)
        modifier.push("link-button--small-padding");
      return modifier;
    },
    linkType() {
      if (this.text)
        return "text";
      return "button";
    },
    dataTealium() {
      let dasherizedText;
      if (this.slotContent)
        dasherizedText = slugify(this.slotContent);
      if (this.tealiumName)
        dasherizedText = slugify(this.tealiumName);
      if (!dasherizedText)
        return null;
      if (this.tealiumSuffix) {
        return `content.${this.linkType}.${dasherizedText}.${slugify(this.tealiumSuffix)}`;
      }
      return `content.${this.linkType}.${dasherizedText}`;
    },
    tagComponent() {
      var _a;
      if (this.tag === "nuxt-link" && ((_a = getConfig()) == null ? void 0 : _a.nuxtLink)) {
        return getConfig().nuxtLink;
      }
      return this.tag;
    }
  },
  mounted() {
    this.setSlotContent();
  },
  methods: {
    setSlotContent() {
      var _a;
      this.slotContent = ((_a = this.$el.textContent) == null ? void 0 : _a.toLowerCase()) || "";
    },
    onClick(e) {
      var _a, _b, _c;
      if (((_b = (_a = getConfig()) == null ? void 0 : _a.tealium) == null ? void 0 : _b.link) && this.dataTealium) {
        (_c = getConfig().tealium) == null ? void 0 : _c.link({ wt_link_id: this.dataTealium });
      }
      this.$emit("click", e);
    }
  }
});
export {
  LinkButtonProps,
  _sfc_main as default
};
